module.exports = __webpack_public_path__ + "static/media/help.b8784d20.png";